import { useRef, useState } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as Refresh } from "assets/icons/refresh.svg";

export default function VideoPreview({ durationOfVideo, video, onTryAgain }) {
  const { t } = useTranslation();

  const [playing, setPlaying] = useState(false);
  const [currentDurationOfVideo, setCurrentDurationOfVideo] = useState(0);
  const videoRef = useRef(null);
  const durationRef = useRef(0);

  const handlePlayAndPauseVideo = () => {
    if (!playing) {
      setPlaying(true);
      getDurationOfVideo();
      videoRef.current.play();
    }
  };

  const getDurationOfVideo = () => {
    const time = setInterval(() => {
      if (durationRef.current >= durationOfVideo) {
        clearVideoInterval(0);
        return;
      }
      durationRef.current += 1;
      setCurrentDurationOfVideo(durationRef.current);
    }, 1000);

    const clearVideoInterval = (counter) => {
      setPlaying(false);
      setCurrentDurationOfVideo(counter);
      durationRef.current = counter;
      clearInterval(time);
    };
  };
  return (
    <div className="px-5">
      <div
        className={`relative flex justify-center ${
          video !== null ? "h-auto" : "h-[300px]"
        } items-center rounded-lg w-full overflow-hidden cursor-pointer`}
        onClick={handlePlayAndPauseVideo}
      >
        <div className="w-full h-[300px]">
          <video
            className="w-full object-cover h-full rounded-lg"
            id="video-tag"
            ref={videoRef}
            onError={(err) => {
              console.log("err :>> ", err);
            }}
          >
            <source id="video-source" type="video/mp4" />
            Your browser does not support the video tag.d
          </video>
        </div>
        <div
          className={`absolute transition-all duration-300 left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] cursor-pointer ${
            playing ? "opacity-0" : "opacity-100"
          }`}
        >
          <img
            alt="play"
            className="h-[56px] w-[56px]"
            src={"https://cdn.firouzeh.com/public/play-video.svg"}
          />
        </div>
        {currentDurationOfVideo > 0 && (
          <div className="absolute left-3 bottom-3 text-white caption-12px-regular">
            {`00:${
              currentDurationOfVideo < 10
                ? `0${currentDurationOfVideo}`
                : currentDurationOfVideo
            }`}
          </div>
        )}
      </div>
      <div className="flex justify-between  items-center rounded-lg text-white p-4 shadow-sm mt-2 mb-2">
        <div className="body-14px-regular text-gray-4">بررسی ویدیو ضبط شده</div>
        <Button
          className="flex gap-1 items-center p-0 border-none min-h-0 h-0 text-blue-0 caption-12px-demibold"
          onClick={onTryAgain}
        >
          <Refresh className="w-4 h-4" />
          {t("card-page.try-again")}
        </Button>
      </div>
    </div>
  );
}
